export default "__VITE_ASSET__BjGrKN4j__"